module.exports = __webpack_public_path__ + "static/media/paris-final1.880496a1.png";